import { createContext, MouseEvent } from 'react';

export interface AccessibilityContextInterface {
  isPanelShown: boolean;
  turnOnAccessibilityPanel: (event: MouseEvent<HTMLElement>) => void;
}

const AccessibilityContext = createContext<AccessibilityContextInterface>({
  isPanelShown: false,
  turnOnAccessibilityPanel: () => {},
});

export default AccessibilityContext;
